import { render } from "./ViewCandidatesList.vue?vue&type=template&id=5c3fb63f&scoped=true"
import script from "./ViewCandidatesList.vue?vue&type=script&lang=js"
export * from "./ViewCandidatesList.vue?vue&type=script&lang=js"

import "./ViewCandidatesList.vue?vue&type=style&index=0&id=5c3fb63f&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3fb63f"]])

export default __exports__